import Collection from '@/models/Collection'
import { Category } from '@/models/Category'

export class Categories extends Collection {
	public model() {
		return Category
	}

	public routes() {
		return {
			fetch: 'categories',
		}
	}
}